




















































import SnotifyConfiguration from '@/classes/SnotifyConfiguration';
import { DocumentEmailService } from '@/services/DocumentEmailService';
import { UserService } from '@/services/UserService';
import { EVENT_BUS, StoreConstants } from '@/types';
import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';
import LoadingSpinner from './LoadingSpinner.vue';
import MStoreSpinnerButton from './MStoreSpinnerButton.vue';
import ApiConfiguration from '@/classes/ApiConfiguration';
import { EventBus } from '@/classes/EventBus';

export default Vue.extend({
  props: {
    cabinetId: String,
    documentId: Number,
    documentName: String,
    documentExtension: String,
    isDisabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isLoading: true,
      showEmailToMeModal: false,
      convertToPdf: false,
      isEmailing: false,
      userEmail: '',
      dontAskAgain: false,
      meEmailAddress: '',
      dropdownBoundary: 'viewport',
      checkingFileSizeLimit: false
    };
  },
  computed: {
    ...mapGetters(StoreConstants.UserPreferences.ModuleName, { userEmailToMe: StoreConstants.UserPreferences.Getters.EmailToMe }),
    attachmentExtension(this: any) {
      return this.convertToPdf ? 'PDF' : this.documentExtension;
    }
  },
  methods: {
    ...mapActions(StoreConstants.UserPreferences.ModuleName, [StoreConstants.UserPreferences.Actions.SetEmailToMe]),
    async emailToMe(this: any) {
      this.isEmailing = true;
      try {
        await DocumentEmailService.emailDocumentToMeAsync({
          cabinetId: this.cabinetId,
          documentId: this.documentId,
          convertToPdf: this.convertToPdf
        });

        this[StoreConstants.UserPreferences.Actions.SetEmailToMe]({ convertToPdf: this.convertToPdf, dontAskAgain: this.dontAskAgain });
        SnotifyConfiguration.showSuccess(`Successfully sent to ${this.meEmailAddress}`);
        this.showEmailToMeModal = false;
        EventBus.$emit(EVENT_BUS.DOCUMENT_HISTORY_LOG_UPDATED, true);
      } finally {
        this.isEmailing = false;
      }
    },
    async showModal() {
      this.isLoading = true;
      this.checkingFileSizeLimit = true;
      try {
        await ApiConfiguration.api().documentEmail.documentEmailValidateFileSizeLimitCreate([
          {
            cabinetId: this.cabinetId,
            documentId: this.documentId
          }
        ]);
        this.showEmailToMeModal = true;
      } catch (error) {
        this.$log(error);
        this.showEmailToMeModal = false;
      } finally {
        this.isLoading = false;
        this.checkingFileSizeLimit = false;
      }
    },
    async sendUserPreferenceEmailToMe() {
      if (this.userEmailToMe.dontAskAgain) {
        this.emailToMe();
        return;
      }

      await this.showModal();
    },
    onChangeDontAskAgain(this: any, value: boolean) {
      this.dontAskAgain = value;
      if (!value) {
        this[StoreConstants.UserPreferences.Actions.SetEmailToMe]({ convertToPdf: this.convertToPdf, dontAskAgain: this.dontAskAgain });
      }
    }
  },
  async mounted(this: any) {
    this.convertToPdf = this.userEmailToMe?.convertToPdf ?? false;
    this.dontAskAgain = this.userEmailToMe?.dontAskAgain ?? false;
    try {
      this.meEmailAddress = (await UserService.getCurrentUserAsync()).emailAddress;
    } finally {
      this.isLoading = false;
    }
    this.dropdownBoundary = document.getElementById('viewerContainer') ?? 'viewport';
  },
  components: { LoadingSpinner, MStoreSpinnerButton }
});
